import { FETCH_MEASURED_ENERGY_SUCCESS } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[FETCH_MEASURED_ENERGY_SUCCESS](null);
